import { createTheme } from '@mui/material/styles';

import { v2Colors } from './theme';

/** @deprecated Prefer `v2Colors.primary` from `./theme` */
export const V2_PRIMARY_MAIN = v2Colors.primary;

/** @deprecated Prefer `v2Colors.primaryDark` from `./theme` */
export const V2_PRIMARY_DARK = v2Colors.primaryDark;

export const v2MuiTheme = createTheme({
  palette: {
    primary: {
      main: v2Colors.primary,
      dark: v2Colors.primaryDark,
    },
    background: {
      default: v2Colors.canvas,
      paper: v2Colors.white,
    },
  },
  components: {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          '&.Mui-selected': {
            color: v2Colors.white,
            backgroundColor: v2Colors.primary,
            '&:hover': {
              backgroundColor: v2Colors.primaryDark,
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          '&:hover': {
            backgroundColor: v2Colors.primaryDark,
          },
        },
      },
    },
  },
});
